module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Black.f54360a1.eot";